import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import Panel from "../ui/Panel";
import BaseInput from "../ui/BaseInput";
import SubTitle from "../ui/text/SubTitle";
import Button from "../ui/Button";
import {doPostLogin} from "../../../logics/auth";
import {useAuth} from "../../../utils/contexts/auth-context";

const LoginForm = () => {
    const navigate = useNavigate();
    const {login} = useAuth();
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let response = await doPostLogin(user, password);
        if (response) {
            if (response.token) {
                login();
                sessionStorage.setItem('@auth_token', response.token);
                navigate('/home');
            }
        }
    }

    return (
        <Panel>
            <SubTitle className="mb-2">Insert your credentials</SubTitle>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                <BaseInput value={user}
                           onChange={(e) => setUser(e.currentTarget.value)}
                           required={true}
                           placeholder={"Email"}/>
                <BaseInput value={password}
                           type='password'
                           onChange={(e) => setPassword(e.currentTarget.value)}
                           required={true}
                           placeholder={"Password"}/>

                <Button type='submit' className="mt-2">{"Accedi"}</Button>
            </form>
        </Panel>
    );
};

export default LoginForm;
